module.exports = __webpack_public_path__ + "static/media/dungeon.4b1ffc7a.svg";